import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export type SaveDraftDialogResult = { action: 'save'; name: string | null } | { action: 'exit' };

// Uscita da una proposta mai salvata: bozza col nome facoltativo oppure niente
@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-save-draft-dialog',
  imports: [TranslocoPipe, MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
  template: `
    <h2 mat-dialog-title class="save-draft-title">{{ 'orders.ui.vuoiSalvareComeBozza' | transloco }}</h2>
    <mat-dialog-content class="save-draft-content">
      <span class="body-small">
        {{ 'orders.ui.laPropostaDOrdineVerraSalvataComeBozzaEPotraiRiprenderlaEntro' | transloco }} <strong>{{ 'orders.ui.90Giorni' | transloco }}</strong>
      </span>
      <span class="body-medium-emphasized">{{ 'orders.ui.nomeBozza' | transloco }} <span class="body-medium">{{ 'orders.ui.opzionale' | transloco }}</span></span>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <input matInput [placeholder]="'orders.ui.nomeBozza2' | transloco" [formControl]="name">
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions class="save-draft-actions">
      <button matButton="filled" type="button" (click)="save()">{{ 'orders.ui.salvaBozza' | transloco }}</button>
      <button matButton="outlined" type="button" class="save-draft-exit" (click)="exit()">{{ 'orders.ui.esciSenzaSalvare' | transloco }}</button>
      <button matButton type="button" mat-dialog-close>{{ 'orders.ui.annulla' | transloco }}</button>
    </mat-dialog-actions>
  `,
  styles: `
    .save-draft-title {
      text-align: center;
    }

    .save-draft-content {
      display: flex;
      flex-direction: column;
      gap: var(--mat-sys-spacing-8);
    }

    .save-draft-actions {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: var(--mat-sys-spacing-8);
    }

    .save-draft-exit {
      color: var(--mat-sys-error);
      border-color: var(--mat-sys-error);
    }
  `,
})
export class SaveDraftDialog {
  private readonly dialogRef = inject<MatDialogRef<SaveDraftDialog, SaveDraftDialogResult>>(MatDialogRef);
  readonly name = new FormControl('', { nonNullable: true });

  save(): void {
    this.dialogRef.close({ action: 'save', name: this.name.value.trim() || null });
  }

  exit(): void {
    this.dialogRef.close({ action: 'exit' });
  }
}
